// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import PdfCarouselController from "./pdf_carousel_controller"
application.register("pdf-carousel", PdfCarouselController)

import "./railsui"
